module.exports = __webpack_public_path__ + "img/banner-bcg.591d2e94.png";